import { Delete, Edit } from "@mui/icons-material";
import {
	Button,
	Checkbox,
	FormControlLabel,
	IconButton,
	Paper,
	Radio,
	TextField,
	ToggleButton,
	ToggleButtonGroup,
	Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CreateQuestModal from "../components/CreateQuestModal";
import Loader from "../components/Loader";
import { QuestType } from "../Enums/Test";
import { Answer, ApproveAnswer, Question } from "../interfaces/Test";
import { AproovedTest, CreateTest, GetTest } from "../requester/functions";
import { getUrlId, getUrlUserTestIds } from "../utilities/validate";

import CheckBoxIcon from "@mui/icons-material/CheckBox";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";

interface IProps {}

const UserTestPage = (props: IProps) => {
	const navigate = useNavigate();
	const location = useLocation();

	const { enqueueSnackbar } = useSnackbar();

	const [questions, setQuestions] = useState<Question[]>([
		{
			id: 1,
			title: "Жи есть, ...",
			type: QuestType.single,
			answers: [
				{
					id: 1,
					text: "Да",
				},
				{
					id: 2,
					text: "Нет",
				},
				{
					id: 3,
					text: "Ты че, э",
				},
			],
			user_answers: [1],
			correct_answers: [1],
		},
		{
			id: 2,
			title: "Благадарю = ...",
			type: QuestType.multiple,
			answers: [
				{
					id: 4,
					text: "Рахмет",
				},
				{
					id: 5,
					text: "Спасибо",
				},
				{
					id: 6,
					text: "Аааай ва, братанчик, от души, красавец",
				},
			],
			user_answers: [4],
			correct_answers: [4, 5, 6],
		},
		{
			id: 3,
			title: "Почеиу Казахстан лучшая страна?",
			type: QuestType.text,
			answers: [],
			user_answers: ["_"],
			correct_answers: ["КАЗАХСТАН!!!"],
		},
	]);
	const [selectedQuest, setSelectedQuest] = useState<Question | undefined>(
		undefined
	);
	const [testName, setTestName] = useState<string>("Казахский");
	const [succesCount, setSuccesCount] = useState<number>(10);

	const [idsData, setIdsData] = useState<{
		id_user: number;
		id_test: number;
	}>();

	const [isLoaded, setIsLoaded] = useState<boolean>(true);

	const [appreovedAnswer, setAppreovedAnswer] = useState<any>({});

	const getAnswerColor = (quest: Question, answer: Answer) => {
		if (quest.correct_answers.includes(answer.id as never)) return "success";
		if (quest.user_answers && quest.user_answers.includes(answer.id as never))
			return "error";
		return "primary";
	};

	const isApproved = () => {
		for (var q of questions)
			if ([undefined, null].includes(appreovedAnswer[q.id || 0])) return false;
		return true;
	};

	const generateApproveds = () => {
		return Object.keys(appreovedAnswer).map(
			(a) =>
				({
					id: parseInt(a),
					success: appreovedAnswer[a] as boolean,
				} as ApproveAnswer)
		);
	};

	useEffect(() => {
		const data: { id_user: number; id_test: number } = getUrlUserTestIds(
			location.pathname
		);
		setIdsData(data)

		GetTest({ id: data.id_test, id_candidate: data.id_user }, (resp) => {
			if (resp.status == "ok" && resp.data) {
				setTestName(resp.data.name);
				setSuccesCount(resp.data.success_count);
				setQuestions(resp.data.questions);

				setIsLoaded(true);
			} else {
				navigate("/tests");
			}
		});
	}, []);

	return isLoaded ? (
		<div className="flex flex-col gap-3 items-start">
			<Typography>{testName}</Typography>
			<div className="flex flex-col gap-3 w-60">
				{questions.map((q, qi) => (
					<Paper key={`quest-${qi}`} className="p-3 w-full">
						<Typography>{q.title}</Typography>
						<div className="flex flex-col">
							{q.type != QuestType.text ? (
								q.answers.map((a, ai) =>
									q.type == QuestType.single ? (
										<div className="flex gap-2 items-center">
											<CheckBoxIcon
												color="success"
												style={{
													opacity: q.correct_answers.includes(a.id as never)
														? 1
														: 0,
												}}
											/>

											<FormControlLabel
												key={`answer-${qi}${ai}`}
												value={a.id}
												control={
													<Radio
														color={getAnswerColor(q, a)}
														checked={
															q.user_answers &&
															q.user_answers.includes(a.id as never)
														}
													/>
												}
												label={a.text}
											/>
										</div>
									) : q.type == QuestType.multiple ? (
										<div className="flex gap-2 items-center">
											<CheckBoxIcon
												color="success"
												style={{
													opacity: q.correct_answers.includes(a.id as never)
														? 1
														: 0,
												}}
											/>
											<FormControlLabel
												label={a.text}
												control={
													<Checkbox
														color={getAnswerColor(q, a)}
														checked={
															q.user_answers &&
															q.user_answers.includes(a.id as never)
														}
													/>
												}
											/>
										</div>
									) : null
								)
							) : (
								<div className="flex flex-col">
									<TextField
										value={
											q.user_answers && q.user_answers.length > 0
												? q.user_answers[0]
												: ""
										}
										error={
											q.user_answers &&
											q.user_answers.length > 0 &&
											q.user_answers[0] != q.correct_answers[0]
										}
										multiline
									/>
									<Typography className="!mt-3">
										{q.correct_answers[0]}
									</Typography>
								</div>
							)}
							<div className="flex  w-full justify-end mt-2">
								<ToggleButtonGroup
									color={appreovedAnswer[q.id || 0] ? "success" : "error"}
									exclusive
									value={appreovedAnswer[q.id || 0]}
									onChange={(
										event: React.MouseEvent<HTMLElement>,
										newApprovement: boolean
									) => {
										setAppreovedAnswer((aa: any) => {
											aa[q.id || 0] = newApprovement;
											return { ...aa };
										});
									}}
									aria-label="Platform"
								>
									<ToggleButton value={false}>
										<DisabledByDefaultIcon />
									</ToggleButton>
									<ToggleButton value={true}>
										<CheckBoxIcon />
									</ToggleButton>
								</ToggleButtonGroup>
							</div>
						</div>
					</Paper>
				))}
			</div>
			<div className="flex gap-2">
				<Button
					variant="contained"
					disabled={!isApproved()}
					onClick={() => {
						if (idsData)
							AproovedTest(
								{
									...idsData,
									answers: generateApproveds(),
								},
								(resp) => {
									if (resp.status == "ok"){
										enqueueSnackbar("Тест успешно проверен", {
											variant: "success",
										});
										navigate(`/candidate/${idsData.id_user}`)
									}
									else enqueueSnackbar(resp.message, { variant: "error" });
								}
							);
					}}
				>
					потдвердить
				</Button>
			</div>
		</div>
	) : (
		<Loader />
	);
};

export default UserTestPage;
